import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Dashboard from './views/Dashboard.vue'
import Host from './views/Host.vue'
import Club from './views/Club.vue'
import Thanks from './views/Thanks.vue'
import Checkout from './views/Checkout.vue'
import Login from './views/Login.vue'
import Orders from './views/Orders.vue'
import Order from './views/Order.vue'
import Settings from './views/Settings.vue'
import Register from './views/Register.vue'
import store from "@/store";
//import { App, URLOpenListenerEvent } from '@capacitor/app';

Vue.use(Router);

const router = new Router({
  scrollBehavior: () => ({ y: 0 }),
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      props: true,
      meta: {
        guest: true,
        banner: true,
        redDir: true
        //guest: true,
        //is_admin : true
      },
    },
    {
      path: "/register",
      name: "register",
      component: Register,
      props: true,
      meta: {
        banner: true
        //is_admin : true
      },
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      props: true,
      meta: {
        banner: true

        //is_admin : true
      },
    },
    {
      path: "/orders",
      name: "orders",
      component: Orders,
      props: true,
      meta: {
        requiresAuth: true,
        banner: true
      
        //is_admin : true
      },
    },
    {
      path: "/organisation/:index",
      name: "host",
      component: Host,
      props: true,
      meta: {
       banner: true
        //is_admin : true
      },
    },
    {
      path: "/organisation/:index/info",
      name: "hostinfo",
      component: Host,
      props: true,
      meta: {
        //requiresAuth: true,
        banner: true
        //is_admin : true
      },
    },
    {
      path: "/club/:index",
      name: "club",
      component: Club,
      props: true,
      meta: {
        requiresAuth: true,
        banner: true

        //is_admin : true
      },
    },
    {
      path: "/thanks/:index",
      name: "thanks",
      component: Thanks,
      props: true,
      meta: {
          banner: true
        //is_admin : true
      },
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings,
      props: true,
      meta: {
        requiresAuth: true,
        banner: true
        //is_admin : true
      },
    },
    
    
    {
      path: "/order/:index",
      name: "order",
      component: Order,
      props: true,
      meta: {
        requiresAuth: true,
        banner: true
        //is_admin : true
      },
    },
    {
      path: "/checkout",
      name: "checkout",
      component: Checkout,
      props: true,
      meta: {
        //requiresAuth: false,
        banner: true
        //guest: true,
        //is_admin : true
      },
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      props: true,
      meta: {
        banner: false
      },
    },
  ],
});
/*App.addListener('appUrlOpen', function (event) { //: URLOpenListenerEvent
  // Example url: https://beerswift.app/tabs/tabs2
  // slug = /tabs/tabs2
  const slug = event.url.split('.app').pop();

  // We only push to the route if there is a slug present
  if (slug) {
    router.push({
      path: slug,
    });
  }
});*/
import { Capacitor } from "@capacitor/core";
var isMobile = false; //initiate as false
var isNative = Capacitor.isNativePlatform()
// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    isMobile = true;
}

let location = window.location.host.toString()
let perma = (location.split(".")[1] == 'eetplein') ? location.split(".")[0] : null
if (!perma && !location.includes('eetplein') &&  !location.includes('localhost')) perma = 'www'

router.beforeEach((to, from, next) => {
  let route, authenticated = store.getters.authenticated
  to.matched.some((record) => route = record)
  //console.log(to.fullPath,Vue.$vuetify,isMobile)
  //secure
  //if (!route.meta.requiresAuth && !authenticated) return next({path: "/login", query: { redir: to.fullPath }});
  
  if (route.meta.guest && authenticated) return next({path: "/dashboard"});
  if (!location.includes(':') && to.matched.some((record) => record.meta.redDir) && perma && !['mijn', 'app', "www", 'login'].includes(perma) ) {
   /* return next({
        path: "/organisation/info",
        query: to.query,
      })*/
  }
  if (to.fullPath == '/' && isNative) return  next({ name: "login" });
  next()
  /*if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.authenticated) {
      if (to.matched.some((record) => record.meta.redDir) && perma && !['mijn', 'app', 'login'].includes(perma) ) {
        return next({
            path: "/organisation/info",
            query: to.query,
          })
      }
      next({
        path: "/login",
        query: { redir: to.fullPath },
      });
    } else {
      if (to.matched.some((record) => record.meta.is_admin)) {
        if (store.user.is_admin == 1) {
          next();
        } else {
          next({ name: "home" });
        }
      } else {
        next();
      }
    }
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (store.token !== null) {
      next({ name: "dashboard" });
    } else {
      next();
    }
  } else {
    next({ name: "home" });
  }*/
});

export default router;
